
export const API_URL = "";
// export const API_URL = "https://api.bscs.finance/api";
export const BSCSCAN_API_MAINNET = "https://api.bscscan.com";
export const BSCSCAN_APIKEY = "T2IXE481IAX4947JTMHSB7482992S7VE1W";
export const MAPPING_CHAINID: any = {
  bep: "0x38",
  erc: "0x1",
  poly: "0x89",
  fmt: "0xfa",
  okc: "0x42",
  avax: "0xa86a",
  op: "0xa",
  doge: "0x7d0",
  arb: "0xa4b1",
  opbnb: "0xcc",
  base: "0x2105",
  zkevm: '0x343b',
  blast: '0x13e31',
  sei: '0x531',
};
export const MAPPING_CHAINID_AIR: any = {
  bep: 56,
  erc: 1,
  poly: 137,
  fmt: 250,
  okc: 66,
  avax: 43114,
  op: 10,
  doge: 2000,
  arb: 42161,
  opbnb: 204,
  base: 8453,
  zkevm: 13371,
  blast: 81457,
  sei: 1329
};
export const CHAINID_CONVERT: any = {
  56: "bep",
  1: "erc",
  137: "poly",
  66: "okc",
  42161: "arb",
  204: "opbnb",
  8453: "base",
  13371: 'zkevm',
  43114: 'avax',
  1329: 'sei',
};
export const KEY_CRYPTOJS = "4kHlZXyYTew38QnxvWFnag==";
export const ADDRESS_BSCS_ADDRESS = "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d";
export const NETWORK_CHAIN_ID: number = parseInt(
  process.env.REACT_APP_CHAIN_ID ?? "56"
);
export const CHAIN_NETWORK_APTOS = "https://fullnode.mainnet.aptoslabs.com/v1";
export const TYPE_APT_TOKEN = "0x1::coin::CoinStore<0x1::aptos_coin::AptosCoin>";
export const SC_STAKE_BSCS = "0x0eC48e293f34680EF14055AD14d84b2E83A9d6B1"
export const SC_STAKE_BSCS_CUSTOM = "0xe190927BA9dc27A17442050705fce40635DAfcE3"
// export const SC_STAKE_BSCS_CUSTOM = "0x74642c1Baa158956111AC5170f49C6dBAecBb969"

const BSCSs: any = {
  56: "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d",
  97: "0xE1068958C357e84f2C065D8C9b9f15C70028B546",
};
export const TOKEN_BSCS = BSCSs[NETWORK_CHAIN_ID];

// ----------------------------------------------------
export const ACCOUNT_URL = "/my-account";
export const ICUBATOR = "/incubator-program";
export const HOME = "/";
export const NFT_URL = "https://nft.bscs.finance";
export const AIR_DROP = "https://xconnect.bscs.finance/airdrop";
export const LAUNCHPAD_URL = "/Ido";
export const IDO_DETAIl_APT = "/Ido/IdoDetails/:network";
export const IDO_DETAIl_TON = "/Ido/Detail/:network";
export const IDO_DETAIl_SOL = "/Ido/IdoDetail/:network";
export const IDO_DETAIl_OLD = "/Ido/IdoDetails/";
export const IDO_DETAIl = "/Ido/Details/";
export const IDO_DETAIl_VANG = "/Ido/details-vanguard/";
export const IDO_FULL_SEARCH = "/Ido/FullSearchProject";
export const LAUNCHPOOL_URL = "/launch-pool";
export const LAUNCHPOOL_DETAIL_URL = "/launch-pool-details/:poolContract";
export const APPLY = "/apply-to-launch";

export const WEB3 = "https://bscs.finance/web3-ignite";
export const BRAND_ASSET = "https://bscs.finance/brand";
export const BSCS_VERIFY = "https://bscs.finance/verify";
export const TOKEN_NOMICS = "https://bscs.finance/static/media/Tokenomics2.d346f29955b6ae411460.pdf";
export const TERMS = "https://bscs.finance/term";
export const PRIVACY = "https://bscs.finance/privacy";
export const COOKIES = "https://bscs.finance/cookie";
export const BUILDERS = "https://t.me/BSCS_Channel/4059";

// ----------------------------------------------------

export const DOCS_URL = "https://docs.bscstation.finance/";
export const GITHUB_URL = "https://github.com/BSCSGlobal";
export const CERTIK_AUDIT_URL = "https://skynet.certik.com/projects/bscs";
export const Quillhash_AUDIT_URL =
  "https://github.com/Quillhash/QuillAudit_Reports/blob/master/BSCS%20Smart%20Contract%20Audit%20Report%20-%20QuillAudits.pdf";
export const PECKSHIELD_AUDIT_URL =
  "https://github.com/peckshield/publications/blob/master/audit_reports/PeckShield-Audit-Report-BSCStationStartPools-v1.0.pdf";
export const SolidProof_URL =
  "https://github.com/solidproof/projects/tree/main/BSCStation";
export const TWITTER_URL = "https://twitter.com/BSCS_Global";
export const TELEGRAM_URL = "https://t.me/BSCS_Channel";
export const FACE_URL = "https://www.facebook.com/BSCS.Channel";
export const YOUTUBE_URL = "https://www.youtube.com/@BSCSOfficial";
export const REDIT_URL = "https://www.reddit.com/r/BSCStation/";
export const SUBSTACK = "https://bscstation.substack.com/";

// ----------------------------------------------------

export const ICON_BNB_URL =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/e3828a3eb62a65a551423b45d04a4c816e92d347be968298bb.png";
export const ICON_OPBNB_URL =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/e3828a3eb62a65a551423b45d04a4c816e92d347be968298bb.png";
export const ICON_ETH_URL =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/816fa85de2c761a9dac2e5770f0b08738177d6995efda00fee.png";
export const ICON_POLY_URL =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/9970ad6f8e2d9b36ab187859b143093a544eaf1f69c3202e0a.png";

export const LOGO_ICON =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/ae1e8eff3079d9e6fda98d093af950a6cc73745e669c4a85f3.png";

export const ICON_OKEX =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/9be394a592a19934e5066d58ceb0a2d950668139b3199c9adf.png";
export const ICON_AVAX =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/adb2afbda8bb2acb7d15e8d209981919841009d3f12187f2fc.png";
export const ICON_OP =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/13dfe69f3ccf21e7579385e316f2f07e9d51c2cf7be5e321ed.png";
export const ICON_DOGE =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/3fa42fb64f69685000dbd30173274b2ee73d815bf67d131e34.png";
export const ICON_FMT =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/ff78a6f70a8d833aa32bbdbd7ae7087e68014e27d682387ef8.png";
export const ICON_ARB =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/6fc117523771441b9c43a0e1e00d04e5279127ebcc3c7870a9.png";
export const ICON_BASE =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/438026a4dc0063a49b85dba902070e4343ec0a1eb27adad29e.png";
export const ICON_ZK =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/fc32b1c4f9d077d349a3f532c1143d34c75ff3c7810625cbb2.jpeg";
export const ICON_BLAST =
  "https://s3-ap-southeast-1.amazonaws.com/bscstation.org/images/00b71eeb7fe55ab613c2da6361ca080cfdb110349e8b35ebef.jpeg";
export const ICON_SEI = "https://icons.llamao.fi/icons/chains/rsz_sei.jpg"

